import Icon from '@ant-design/icons';
import { Col } from 'antd';
import { ImageItemProps } from 'features/tradingsetup/components/ImageItem';
import useCuratorFeedStore from 'global/CuratorIO/stores/useCuratorFeedsStore';
import ChevronDownSvg from 'global/Securities/components/Icons/ChevronDownSvg';
import Link from 'next/link';
import { useEffect, useMemo } from 'react';
import shallow from 'zustand/shallow';
import {
  ImageItem,
  ImageListRow,
  MobileImageList,
  SeeGallery,
  ShareColumnContainer,
  ShareImgBody,
  ShareImgContainer,
  ShareYourSetupSection,
  ShareYourSetupTitle,
} from './styled';

const ShareYourSetup = () => {
  const [feedPosts, loadCuratorFeed] = useCuratorFeedStore(
    (s) => [s.data?.posts || [], s.loadCuratorFeed],
    shallow,
  );

  const getPostProps = (postIndex: number): ImageItemProps => {
    const {
      user_screen_name: username,
      user_image: userImgSrc,
      image_large: src,
      url: href,
    } = feedPosts[postIndex] || {};
    return {
      username,
      userImgSrc,
      src,
      href,
    };
  };

  const mobilePostList = useMemo(
    () =>
      new Array(7).fill('').map((_, index) => (
        <div key={index.toString()}>
          <ImageItem width="160px" height="160px" {...getPostProps(index)} />
        </div>
      )),
    [feedPosts],
  );

  useEffect(() => {
    loadCuratorFeed();
  }, []);

  return (
    <ShareYourSetupSection>
      <ShareYourSetupTitle>
        User Experience with
        <br />
        <span className="green">#StockbitDesktopApp</span>
      </ShareYourSetupTitle>

      <ImageListRow>
        <Col xs={0} lg={24}>
          <ShareImgBody>
            <ShareImgContainer>
              <ImageItem width="265px" {...getPostProps(0)} />
              <ShareColumnContainer width="315px">
                <ImageItem height="192px" {...getPostProps(1)} />
                <ImageItem height="196px" {...getPostProps(2)} />
              </ShareColumnContainer>
              <ShareColumnContainer width="256px">
                <ImageItem height="151px" {...getPostProps(3)} />
                <ImageItem height="238px" {...getPostProps(4)} />
              </ShareColumnContainer>
              <ShareColumnContainer width="265px">
                <ImageItem height="272px" {...getPostProps(6)} />
                <ImageItem height="116px" {...getPostProps(7)} />
              </ShareColumnContainer>
            </ShareImgContainer>
          </ShareImgBody>
        </Col>
        <Col xs={24} lg={0}>
          <MobileImageList>{mobilePostList}</MobileImageList>
        </Col>
      </ImageListRow>

      <Link href="/desktop/trading-setup">
        <SeeGallery>
          See All
          <Icon
            component={ChevronDownSvg}
            style={{ transform: 'rotate(-90deg)' }}
          />
        </SeeGallery>
      </Link>
    </ShareYourSetupSection>
  );
};

export default ShareYourSetup;
